<template>
  <section>
    <p v-if="displayError" class="error-box"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>{{ displayError }}</p>
    <div v-if="isLoading && agreements.length == 0" class="loading-spinner">
      <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
    </div>
    <div v-for="(agreement, index) in agreements" :key="index">
      <agreement
        :agreement="agreement"
        v-on:reload-all-agreements="loadAgreements()"
      />
    </div>
    <section v-if="!isLoading && agreements && agreements.length == 0">
      <div class="alert alert-info" role="alert">
        žádné smlouvy
      </div>
    </section>

  </section>
</template>

<script>
import AgreementResource from '../backend-resources/agreement-resource'
import Agreement from '@/components/Agreement'

export default {
  data () {
    return {
      agreements: [],
      displayError: null,
      isLoading: false,
    }
  },
  created: function () {
    this.loadAgreements()
  },
  components: {
    agreement: Agreement
  },
  methods: {
    loadAgreements: function () {
      this.isLoading = true
      AgreementResource.get().then((response) => {
        this.agreements = response.data
        this.displayError = null
        this.isLoading = false
      }).catch((error) => {
        this.displayError = error.response.status + ' ' + error.response.statusText
        this.agreements = null
        this.isLoading = false
      })
    },
  },
  computed: {
  }
}
</script>
<style scoped>
agreement {
  padding-left: 0;
  margin-left: 0;
}
.add {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// MyAgreements.vue?37aa0bc0